import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { UserComponent } from './pages/users/user.component';
import { AvaUnespComponent } from './pages/ava-unesp/ava-unesp.component';
import { MyDocumentsComponent } from "./pages/my-documents/my-documents.component";
import { ForgotUsernameComponent } from './pages/forgot-username/forgot-username.component';
import { ChangePasswordComponent } from "./pages/change-password/change-password.component";
import { OauthCallbackComponent } from './pages/oauth-callback/oauth-callback.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { ValidationDocumentComponent } from "./pages/validation-document/validation-document.component";
import { ExternalRedirectComponent } from "./pages/external-redirect/external-redirect.component";
import { PagenotfoundComponent } from "./pages/pagenotfound/pagenotfound.component";

export const routes: Routes = [
  { path: '', component: ExternalRedirectComponent },
  { path: 'oauth', component: OauthCallbackComponent },
  { path: 'login', component: LoginComponent },
  { path: 'ava-unesp', component: AvaUnespComponent, canActivate: [AuthGuard] },
  { path: 'meu-perfil', component: UserComponent, canActivate: [AuthGuard] },
  { path: 'meus-documentos', component: MyDocumentsComponent, canActivate: [AuthGuard] },
  { path: 'esqueci-minha-senha', component: ForgotPasswordComponent, data: { tipo: 'senha' } },
  { path: 'esqueci-meu-usuario', component: ForgotUsernameComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'consulta-documento', component: ValidationDocumentComponent },
  { path: 'alterar-senha', component: ChangePasswordComponent, canActivate: [AuthGuard] },
  { path: '**', component: PagenotfoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
